// extracted by mini-css-extract-plugin
export var currencyInput = "_oa-1";
export var currencySymbol = "_oa-0";